import React, { useState, useEffect } from "react"
import Layout from "../components/layout"
import { graphql, useStaticQuery, Link } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"

import * as styles from "../styles/testimonials.module.css"
import TextField from "@material-ui/core/TextField"
import Autocomplete from "@material-ui/lab/Autocomplete"
import Checkbox from "@material-ui/core/Checkbox"
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank"
import CheckBoxIcon from "@material-ui/icons/CheckBox"
import { Pagination } from "@material-ui/lab"
import MenuItem from "@material-ui/core/MenuItem"
import Select from "@material-ui/core/Select"
import { Box } from "@material-ui/core"

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />
const checkedIcon = <CheckBoxIcon fontSize="small" />
export default function Testimonials() {

  // Data Fetching

  const {
    allStrapiTestimonial,
    allStrapiBranch,
    allStrapiCgpaRange,
    allStrapiField,
    allStrapiCompany,
    allStrapiGradyear,
    allStrapiHighstudies,
    allStrapiLocation,
    allStrapiTag,
    allStrapiUniversity,
  } = useStaticQuery(graphql`
    {
      allStrapiCompany {
        edges {
          node {
            id
            name
          }
        }
      }
      allStrapiGradyear {
        edges {
          node {
            id
            year
          }
        }
      }
      allStrapiHighstudies {
        edges {
          node {
            id
            name
          }
        }
      }
      allStrapiLocation {
        edges {
          node {
            name
            id
          }
        }
      }
      allStrapiTag {
        edges {
          node {
            name
            id
          }
        }
      }
      allStrapiUniversity {
        edges {
          node {
            name
            id
          }
        }
      }
      allStrapiField {
        edges {
          node {
            id
            name
          }
        }
      }
      allStrapiCgpaRange {
        edges {
          node {
            id
            name
          }
        }
      }
      allStrapiBranch {
        edges {
          node {
            name
            id
          }
        }
      }
      allStrapiTestimonial {
        edges {
          node {
            tags {
              id
              name
            }
            locations {
              id
              name
            }
            gradyear {
              id
              year
            }
            companies {
              id
              name
            }
            highstudies {
              id
              name
            }
            universities {
              id
              name
            }
            strapiFields {
              id
              name
            }
            cgpa_range {
              id
              name
            }
            CGPA
            branches {
              name
              id
            }
            name
            id
            displaypicture {
              childImageSharp {
                gatsbyImageData
              }
            }
          }
        }
      }
    }
  `)

  // Filtering Logic
  
  const testimonials = allStrapiTestimonial.edges.map(edge => edge.node)
  const [allTestimonials, setAllTestimonials] = useState(testimonials)
  const [branchArray, setBranchArray] = useState([])
  const [cgArray, setCGArray] = useState([])
  const [fieldArray, setFieldArray] = useState([])
  const [companyArray, setCompanyArray] = useState([])
  const [highStudiesArray, setHighStudiesArray] = useState([])
  const [universityArray, setUniversityArray] = useState([])
  const [locationArray, setLocationArray] = useState([])
  const [gradYearArray, setGradYearArray] = useState([])
  const [tagArray, setTagArray] = useState([])
  useEffect(() => {
    let tempTestimonials = testimonials
    tempTestimonials = testimonials.filter(testimonial => {
      const testimonialBranches = testimonial.branches.map(item => item.name)
      const testimonialFields = testimonial.strapiFields.map(item => item.name)
      const testimonialCompanies = testimonial.companies.map(item => item.name)
      const testimonialHighStudies = testimonial.highstudies.map(
        item => item.name
      )
      const testimonialUniversities = testimonial.universities.map(
        item => item.name
      )
      const testimonialLocations = testimonial.locations.map(item => item.name)
      const testimonialTags = testimonial.tags.map(item => item.name)

      return (
        (branchArray.length > 0
          ? branchArray.every(item => testimonialBranches.includes(item))
          : true) &&
        (cgArray.length > 0 && testimonial.cgpa_range
          ? cgArray.includes(testimonial.cgpa_range.name)
          : true) &&
        (fieldArray.length > 0
          ? fieldArray.every(item => testimonialFields.includes(item))
          : true) &&
        (companyArray.length > 0
          ? companyArray.every(item => testimonialCompanies.includes(item))
          : true) &&
        (highStudiesArray.length > 0
          ? highStudiesArray.every(item =>
              testimonialHighStudies.includes(item)
            )
          : true) &&
        (universityArray.length > 0
          ? universityArray.every(item =>
              testimonialUniversities.includes(item)
            )
          : true) &&
        (locationArray.length > 0
          ? locationArray.every(item => testimonialLocations.includes(item))
          : true) &&
        (tagArray.length > 0
          ? tagArray.every(item => testimonialTags.includes(item))
          : true) &&
        (gradYearArray.length > 0 && testimonial.gradyear
          ? gradYearArray.includes(testimonial.gradyear.year)
          : true)
      )
    })
    setAllTestimonials(tempTestimonials)
  }, [
    branchArray,
    cgArray,
    fieldArray,
    companyArray,
    highStudiesArray,
    universityArray,
    locationArray,
    tagArray,
    gradYearArray,
  ])
  return (
    <Layout>
      <div className={styles.landing}></div>
      {/* Filters */}
      <div className={styles.filterContainer}>
        <div className={styles.filterWrapper}>
          <Autocomplete
            multiple
            id="checkboxes-tags-demo"
            options={allStrapiField.edges.map(({ node }) => node.name)}
            renderOption={(option, { selected }) => (
              <React.Fragment>
                <Checkbox
                  icon={icon}
                  checkedIcon={checkedIcon}
                  style={{ marginRight: 8 }}
                  checked={selected}
                />
                {option}
              </React.Fragment>
            )}
            renderInput={params => (
              <TextField {...params} variant="outlined" label="Fields" />
            )}
            onChange={(evt, value) => setFieldArray(value)}
          />
          <Autocomplete
            multiple
            id="checkboxes-tags-demo"
            options={allStrapiCompany.edges.map(({ node }) => node.name)}
            renderOption={(option, { selected }) => (
              <React.Fragment>
                <Checkbox
                  icon={icon}
                  checkedIcon={checkedIcon}
                  style={{ marginRight: 8 }}
                  checked={selected}
                />
                {option}
              </React.Fragment>
            )}
            renderInput={params => (
              <TextField {...params} variant="outlined" label="Companies" />
            )}
            onChange={(evt, value) => setCompanyArray(value)}
          />
        </div>
        <div className={styles.filterWrapper}>
          <Autocomplete
            multiple
            id="checkboxes-tags-demo"
            options={allStrapiHighstudies.edges.map(({ node }) => node.name)}
            renderOption={(option, { selected }) => (
              <React.Fragment>
                <Checkbox
                  icon={icon}
                  checkedIcon={checkedIcon}
                  style={{ marginRight: 8 }}
                  checked={selected}
                />
                {option}
              </React.Fragment>
            )}
            renderInput={params => (
              <TextField
                {...params}
                variant="outlined"
                label="Higher Studies"
              />
            )}
            onChange={(evt, value) => setHighStudiesArray(value)}
          />
          <Autocomplete
            multiple
            id="checkboxes-tags-demo"
            options={allStrapiUniversity.edges.map(({ node }) => node.name)}
            renderOption={(option, { selected }) => (
              <React.Fragment>
                <Checkbox
                  icon={icon}
                  checkedIcon={checkedIcon}
                  style={{ marginRight: 8 }}
                  checked={selected}
                />
                {option}
              </React.Fragment>
            )}
            renderInput={params => (
              <TextField {...params} variant="outlined" label="University" />
            )}
            onChange={(evt, value) => setUniversityArray(value)}
          />
        </div>
        <div className={styles.filterWrapper}>
          <Autocomplete
            multiple
            id="checkboxes-tags-demo"
            options={allStrapiBranch.edges.map(({ node }) => node.name)}
            renderOption={(option, { selected }) => (
              <React.Fragment>
                <Checkbox
                  icon={icon}
                  checkedIcon={checkedIcon}
                  style={{ marginRight: 8 }}
                  checked={selected}
                />
                {option}
              </React.Fragment>
            )}
            renderInput={params => (
              <TextField {...params} variant="outlined" label="Branches" />
            )}
            onChange={(evt, value) => setBranchArray(value)}
          />
          <Autocomplete
            multiple
            id="checkboxes-tags-demo"
            options={allStrapiCgpaRange.edges.map(({ node }) => node.name)}
            renderOption={(option, { selected }) => (
              <React.Fragment>
                <Checkbox
                  icon={icon}
                  checkedIcon={checkedIcon}
                  style={{ marginRight: 8 }}
                  checked={selected}
                />
                {option}
              </React.Fragment>
            )}
            renderInput={params => (
              <TextField {...params} variant="outlined" label="CGPA" />
            )}
            onChange={(evt, value) => setCGArray(value)}
          />
          <Autocomplete
            multiple
            id="checkboxes-tags-demo"
            options={allStrapiGradyear.edges.map(({ node }) => node.year)}
            renderOption={(option, { selected }) => (
              <React.Fragment>
                <Checkbox
                  icon={icon}
                  checkedIcon={checkedIcon}
                  style={{ marginRight: 8 }}
                  checked={selected}
                />
                {option}
              </React.Fragment>
            )}
            renderInput={params => (
              <TextField
                {...params}
                variant="outlined"
                label="Graduation Year"
              />
            )}
            onChange={(evt, value) => setGradYearArray(value)}
          />
        </div>
        <div className={styles.filterWrapper}>
          <Autocomplete
            multiple
            id="checkboxes-tags-demo"
            options={allStrapiLocation.edges.map(({ node }) => node.name)}
            renderOption={(option, { selected }) => (
              <React.Fragment>
                <Checkbox
                  icon={icon}
                  checkedIcon={checkedIcon}
                  style={{ marginRight: 8 }}
                  checked={selected}
                />
                {option}
              </React.Fragment>
            )}
            renderInput={params => (
              <TextField {...params} variant="outlined" label="Location" />
            )}
            onChange={(evt, value) => setLocationArray(value)}
          />

          <Autocomplete
            multiple
            id="checkboxes-tags-demo"
            options={allStrapiTag.edges.map(({ node }) => node.name)}
            renderOption={(option, { selected }) => (
              <React.Fragment>
                <Checkbox
                  icon={icon}
                  checkedIcon={checkedIcon}
                  style={{ marginRight: 8 }}
                  checked={selected}
                />
                {option}
              </React.Fragment>
            )}
            renderInput={params => (
              <TextField
                {...params}
                variant="outlined"
                label="Additional Tags"
              />
            )}
            onChange={(evt, value) => setTagArray(value)}
          />
        </div>
      </div>
      <div className={styles.grid}>
        {allTestimonials.length > 0 &&
          allTestimonials.map(item => (
            <div className={styles.item} key={item.id}>
              <GatsbyImage
                image={item.displaypicture.childImageSharp.gatsbyImageData}
                style={{ width: "250px", height: "250px", borderRadius: "50%" }}
              />
              <div className={styles.itemInfo}>
                <h2>{item.name}</h2>
                <Link
                  className={styles.knowmore}
                  to={`/testimonial/${item.id.substr(12)}`}
                >
                  Know More
                </Link>
              </div>
            </div>
          ))}
      </div>
      {/* Testimonials in Grids */}
      {allTestimonials.length === 0 && (
        <h2
          style={{
            fontFamily: "Quicksand",
            textAlign: "center",
            margin: "50px 0",
          }}
        >
          Sorry we haven't found such a senior yet. Drop us an email to let us
          know what you're looking for!
        </h2>
      )}
    </Layout>
  )
}
